module.exports = __webpack_public_path__ + "static/media/users.ae06af1a.svg";